import { render, staticRenderFns } from "./medical-devices.vue?vue&type=template&id=3abbe248&scoped=true&"
import script from "./medical-devices.vue?vue&type=script&lang=js&"
export * from "./medical-devices.vue?vue&type=script&lang=js&"
import style0 from "./medical-devices.vue?vue&type=style&index=0&id=3abbe248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abbe248",
  null
  
)

component.options.__file = "medical-devices.vue"
export default component.exports